<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful title="Employee Recognition :: MeritEHS"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/employees/recognition-list`">
                            <i class="fa fa-trophy"></i> Recognitions
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        {{ recognition.employee_first_name }} {{ recognition.employee_last_name }} for {{ recognition.recognition_name }} on {{ recognition.recognition_date | moment("MM/DD/YYYY") }}
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-8 col-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>
                                Recognition Details
                            </strong>
                            <div class="pull-right">
                                <router-link :to="`/employees/recognition/edit/${this.recognition_id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                                <router-link :to="`/employees/recognition/delete/${this.recognition_id}`" class="btn btn-sm btn-danger">
                                    <i class="fa fa-trash"></i> Delete
                                </router-link>
                                <!-- <button @click="deleteRecognition" class="btn btn-xs btn-danger">
                                    <i class="fa fa-trash"></i> Delete
                                </button> -->
                            </div>
                        </div>
                        <div class="card-body">

                            <div class="row mb-2">
                                <div class="col-md-3 text-muted text-md-right">Employee:</div>
                                <div class="col-md-8">
                                    <template v-if="this.$root.hasPermission('employees.view')">
                                        <router-link :to="`/employees/view/${recognition.employee_id}`">
                                            {{ recognition.employee_first_name }} {{ recognition.employee_last_name }}
                                        </router-link>
                                    </template>
                                    <template v-else>
                                        {{ recognition.employee_first_name }} {{ recognition.employee_last_name }}
                                    </template>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-3 text-muted text-md-right">Employee Craft/Trade:</div>
                                <div class="col-md-8">
                                    {{ recognition.craft }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-3 text-muted text-md-right">Creator</div>
                                <div class="col-md-8">
                                    <a :href="`mailto:${recognition.creator_email}`">
                                        {{ recognition.creator_first_name }} {{ recognition.creator_last_name }}
                                        <span v-if="recognition.creator_deleted_at" class="text-danger">(Deleted On: {{ recognition.creator_deleted_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm a") }}</span>
                                    </a>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-3 text-muted text-md-right">Recognition Type</div>
                                <div class="col-md-8">{{ recognition.recognition_name }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-3 text-muted text-md-right">Superintendent</div>
                                <div class="col-md-8">
                                    <template v-if="this.$root.hasPermission('employees.view')">
                                        <router-link :to="`/employees/view/${recognition.supervisor_id}`">
                                            {{ recognition.super_first_name }} {{ recognition.super_last_name }}
                                        </router-link>
                                    </template>
                                    <template v-else>
                                        {{ recognition.super_first_name }} {{ recognition.super_last_name }}
                                    </template>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-3 text-muted text-md-right">Foreman</div>
                                <div class="col-md-8">
                                    <template v-if="this.$root.hasPermission('employees.view')">
                                        <router-link :to="`/employees/view/${recognition.foreman_id}`">
                                            {{ recognition.foreman_first_name }} {{ recognition.foreman_last_name }}
                                        </router-link>
                                    </template>
                                    <template v-else>
                                        {{ recognition.foreman_first_name }} {{ recognition.foreman_last_name }}
                                    </template>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-3 text-muted text-md-right">Jobsite</div>
                                <div class="col-md-8">
                                    <template v-if="this.$root.hasPermission('jobsites.view') && recognition.jobsite_id">
                                        <router-link :to="`/jobsites/view/${recognition.jobsite_id}`">
                                            {{ recognition.JobsiteNumber }} - {{ recognition.JobsiteName }}
                                        </router-link>
                                    </template>
                                    <template v-else>
                                        {{ recognition.JobsiteNumber }} - {{ recognition.JobsiteName }}
                                    </template>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-3 text-muted text-md-right">Date of Recognition</div>
                                <div class="col-md-8">{{ recognition.recognition_date | moment("MM/DD/YYYY") }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-3 text-muted text-md-right">Status</div>
                                <div class="col-md-8">
                                    <span v-if="recognition.status == 'Open'" class="badge badge-danger">{{ recognition.status }}</span>
                                    <span v-if="recognition.status == 'Closed'" class="badge badge-success">{{ recognition.status }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>
                                Explanation:
                            </strong>
                        </div>
                        <div class="card-body">
                            {{ recognition.explanation }}

                            <div class="row mt-3" v-if="recognition.explanation_file">
                                <div class="col-md-2 text-muted">Explanation File:</div>
                                <div class="col-md-8">
                                    <div>{{ recognition.explanation_file.file_name }}</div>
                                    <span v-if="!recognition.explanation_file.download_only">
                                        <a :href="`/files/view/${recognition.explanation_file.file_id}`" target="_blank">View</a>&nbsp;|&nbsp;
                                    </span>
                                    <a :href="`/files/download/${recognition.explanation_file.file_id}`" target="_blank">Download</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>
                                General Comments:
                            </strong>
                        </div>
                        <div class="card-body">
                            {{ recognition.general_comments }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                userTimezone: this.$store.state.user.timezone,
                saving: false,
                employee_id: this.$route.query.employee_id,
                recognition_id: this.$route.params.id,
                recognition: {},
                errors: {},
                explanation_file: null,
            }
        },

        computed: {
            creator() {
                return {
                    FirstName: this.recognition.creator_first,
                    LastName: this.recognition.creator_last,
                    deleted_at: this.recognition.creator_deleted_at,
                };
            },
        },

        methods: {

            getRecognition: function() {
                //Get the data
                this.$http
                    .get(`employees/recognition/view/${this.recognition_id}`)
                    .then(response => {
                        //Set all the data
                        this.recognition = response.data.recognition;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            // Not actually implemented
            // deleteRecognition: function() {
            //     if(confirm('Are you sure you want to delete this recognition?'))
            //     {
            //         this.$http
            //             .post(`users/delete/${this.UserId}`)
            //             .then(response => {
            //                 this.$router.push('/users');
            //             })
            //             .catch(response => {
            //                 alert('Could not delete user at this time');
            //             });
            //     }
            // },
        },
        mounted() {
            //Get the users
            this.getRecognition();
        }
    }
</script>
